import BaseAPI from "./base/base-api";

class JobPositionAssetAPI extends BaseAPI {
  constructor() {
    super();
  }
  apiName = "Business";
  controllerName = "JobPositionAsset";
}

export default new JobPositionAssetAPI();
